import smoothscroll from 'smoothscroll-polyfill';
import 'babel-polyfill';

// this is required for centerScrollOnFocus()
smoothscroll.polyfill();
